'use client';
import dynamic from 'next/dynamic';
import ClientTestimonials from '@/components/home/client-testimonials';
import ContentCenter from '@/components/common/content-center';
import AboutServies from '@/components/technologies/about-demand';
import ResultMatter from '@/components/common/result-matter';
import HireProcessAbout from '@/components/technologies/hire-process-about';
import DefaultBreadcrumb from '@/components/common/breadcrumbs';
import MetaTags from '@/components/meta-tag/meta-tag';
import { useEffect } from 'react';
import { addIntoLocalStorage } from '@/utils/common-helpers';
import Blog from '@/components/home/blog';
import AboutUsHero from '@/components/common/about-us-hero';
import LifeMowebNew from '@/components/common/life-moweb-new';
const ContactInfo = dynamic(() => import('@/components/common/contact-info'));
const ContactForm = dynamic(() => import('@/components/common/contact-form'));

const Page = () => {
    useEffect(() => {
        addIntoLocalStorage('path-name', window.location.href);
    }, []);

    return (
        <>
            <MetaTags />
            <AboutUsHero />
            <DefaultBreadcrumb currentPage="About Us" />
            <ContentCenter
                title="At Moweb, we help organizations transform, compete, and grow in the digital era - intelligently.
"
            >
                <>
                    <p className="">
                        What started as a small development studio has evolved into a{' '}
                        <b>global, process-driven, innovation-first company</b>. With certified expertise{' '}
                        <b>(ISO 27001:2022 certified & CMMI Level 3 compliant)</b>, disciplined engineering, and a deep
                        understanding of business workflows, we deliver solutions that are{' '}
                        <b>secure, scalable, and future-ready.</b>
                    </p>
                    <p className=" mb-0">
                        Our teams blend <b>human creativity, engineering rigor, and practical AI</b> to solve real-world
                        challenges - from automating enterprise processes to building AI-powered products, advanced mobile & web
                        platforms, workflow systems, and ecosystem-scale solutions.
                    </p>
                </>
            </ContentCenter>
            <LifeMowebNew />
            {/* <LifeMoweb /> */}
            <AboutServies />
            <ResultMatter />
            <HireProcessAbout
                bg="bg-primary"
                pageTitle="How We Do"
                desc="We understand your concerns and that's why we strive to maintain transparency in our work processes."
                white={true}
            />
            <section className="">
                <ClientTestimonials />
            </section>
            <Blog />
            <div className="section bg-primary py-100 dark:text-light dark:bg-black">
                <div className="container lg:container md:mx-auto">
                    <div className="row grid md:grid-cols-12 lg:grid-cols-12">
                        <ContactForm />
                        <ContactInfo />
                    </div>
                </div>
            </div>
        </>
    );
};

export default Page;
